import { render, staticRenderFns } from "./StudentContactBookHeader.vue?vue&type=template&id=112eeaac"
import script from "./StudentContactBookHeader.vue?vue&type=script&lang=js"
export * from "./StudentContactBookHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports